<!--
 * @FileDescription: 库存状况（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-10（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="material-top">
            <div class="material-top-left">
                <a-form :form="form"
                        class="materia-form"
                        layout="inline"
                >
                    <a-row :gutter="24">
                        <a-col :md="4" :sm="8">
                            <a-form-item>
                                <a-input v-decorator="['keywords']" placeholder="请输入商品名称/品牌/型号/规格查询"  @pressEnter="onSearch()" />
                            </a-form-item>
                        </a-col>
                        <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                        <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
                        <span class="materia-form-shua" @click.stop="onRest(2)"><img src="@/assets/image/shuaxin@2x.png"/>刷新</span>
                    </a-row>
                </a-form>
            </div>
          </div>
          <div class="materia-content">
              <div class="commodity-shop-left">
                  <a-input-search  placeholder="请输入分类名称搜索" @change="onChangeInput"  class="tree-input-search"/>
                  <div class="commodity-left-title" @click="onSelectKey('')">全部分类</div>
                  <div class="commodity-tree div-overflow">
                      <treeShopTem ref="treeShopTem" :searchIndex="2" :searchValue="searchValue" @onSelectKey="onSelectKey"></treeShopTem>
                  </div>
              </div>
              <div class="mateia-table-right">
                  <a-table   :columns="columns"
                             :dataSource="dataSourceManage"
                             :pagination="pagination"
                             @change="handleTableChange"
                             :scroll="{y:'calc(100vh - 270px)' }"
                             :rowClassName="rowClassName"
                             rowKey="id"
                             bordered
                  >
                        <template slot="name" slot-scope="text, record">
                            <div class="table-name"><img src="@/assets/image/manage_zong@2x.png" v-if="record.assemblyFlag == 1"/>
                                <a-tooltip placement="top" >
                                    <template slot="title">
                                        <span>{{text}}</span>
                                    </template>
                                    {{text}}
                                </a-tooltip>
                            </div>
                        </template>
                        <template slot="stockCount" slot-scope="text, record">
                             <span  class="table-name1" v-show="!record.ischeck" @click="onClickTab(record)">{{record.stockCount}}</span>
                            <a-input-number class="input-number" :default-value="record.stockCount"  v-if="record.ischeck" v-focus @blur="onBlur(record)"  @change="e => changeNumber(e,record)"  @pressEnter.stop="onPressEnter(record)"></a-input-number>
                        </template>
                      <template slot="state" slot-scope="text, record">
                            <span :class="text == 0 ? 'audit-state' : 'audit-state audit-state1'">
                                  <span class="audit-state-cir"></span>
                                  <span v-if="text == 0">已上架</span>
                                   <span v-else style="color:#ff0000">已下架</span>
                              </span>
                      </template>
                  </a-table>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
//列表没返回
    import treeShopTem from '@/components/treeShopTemcloud'
    import {mixins} from "@/mixins/mixins";
    import {conditionPageList,locationSkuSave,getListPage,updatestornum} from "@/utils/api";
export default {
    name:'materialmanage',
  mixins:[mixins],
  data () {
    return {
        form:this.$form.createForm(this),
        columns: [
            {
                title: '序号',
                dataIndex: '',
                key: 'rowIndex',
                align: 'center',
                customRender(t, r, index) {
                    return parseInt(index) + 1
                }
            },
            {
                title: '商品名称',
                dataIndex: 'name',
                key: 'name',
                width:190,
                ellipsis:true,
                scopedSlots: { customRender: 'name' },
            },
            {
                title: '型号',
                key: 'model',
                ellipsis:true,
                dataIndex: 'model',
            },
            {
                title: '规格',
                key: 'specification',
                ellipsis:true,
                dataIndex:'specification',
            },
            {
                title: '单位',
                key: 'unitName',
                ellipsis:true,
                dataIndex:'unitName',
            },
            {
                title: '售价',
                key: 'retailPrice',
                ellipsis: true,
                align: 'right',
                dataIndex:'retailPrice',
            },
            {
                title: '商品状态',
                key: 'soldOutFlag',
                dataIndex:'soldOutFlag',
                scopedSlots: { customRender: 'state' },
            },
            {
                title: '库存数量',
                key: 'stockCount',
                align: 'right',
                ellipsis: true,
                dataIndex:'stockCount',
                scopedSlots: { customRender: 'stockCount' },
            },
            {
                title: '实际销量',
                key: 'actualSales',
                ellipsis: true,
                align: 'right',
                dataIndex:'actualSales',
            },
        ],
        dataSourceManage: [],
        warehouseState:'',
        isShow:false,
        recordItem:{},
        formData:{
            keywords:'',
            selectKey:'',
        },
        totalCount:0,
        searchValue:'',
    }
  },
  components: {
      treeShopTem
  },
  watch: {
  },
  mounted () {
      this.pagination.pageSize = 40
      this.getListAll()
  },
  created () {

  },
  methods: {
      /**
       * @description: 库存状况列表（方法描述）
       */
      getListAll(){
          this.$store.state.isLoding = true
          getListPage('/mall-goods/web/goodsStock/pageListGoodsStorage', {
              companyStoreId:this.$store.state.shopId,
              keywords:this.formData.keywords,
              categoryId:this.formData.selectKey,
              pageNo:this.pagination.current,
              pageSize:this.pagination.pageSize,
          }, {
              'Content-Type':'application/json',
              companyStoreId:this.$store.state.shopId
          },{
          }).then((res) => {
              if (res.success) {
                  this.$store.state.isLoding = false
                  if (res.result.total !== null && res.result.total !== 'null' && res.result.total !== "") {
                      res.result.total = parseInt(res.result.total)
                      res.result.current = parseInt(res.result.current)
                      res.result.pages = parseInt(res.result.pages)
                      res.result.size = parseInt(res.result.size)
                      this.pagination.current = res.result.current
                      this.pagination.total = res.result.total
                      this.pagination.pageSize =res.result.size
                      this.pages =  res.result.pages
                  }
                  res.result.records.forEach((item)=>{
                      this.$set(item,'ischeck',false)
                  })
                  this.dataSourceManage = res.result.records
              } else {
                  this.$message.warn(res.logMessage)
              }
          })
      },
      //分类回调
      onSelectKey(value){
          this.formData.selectKey = value
          this.pagination.current = 1
          this.onSearch()
          if(this.isEmpty(value)){
              this.$refs.treeShopTem.cancelClass()
          }
      },
      /**
       * @description: tab行的类名（方法描述）
       */
      rowClassName(record,index){
          let className = ''
          if(record.status == 2){
              className = 'tab-row-warn'
          }
          return className
      },
      /**
       * @description: 表格页数切换（方法描述）
       */
      handleTableChange(pagination, filters, sorter){
          console.log(pagination)
          this.pagination.current = pagination.current
          this.pagination.pageSize = pagination.pageSize
          this.getListAll()
      },
      /**
       * @description: 搜索（方法描述）
       */
      onSearch(){
          this.form.validateFields((err, values) => {
              if (!err) {
                  this.pagination.current = 1
                  this.formData.keywords = values.keywords
                  this.warehouseState = values.storageId
                  this.getListAll()
              }
          })
      },
      /**
       * @description: 重置（方法描述）
       */
      onRest(index){
          if(index == 1){

          }else{
              this.formData.selectKey = ''
          }
          this.form = this.$form.createForm(this)
          this.formData.keywords = ''
          this.pagination.current = 1
          if(!this.isEmpty(this.warehouseState)){
              this.columns.splice(this.columns.length - 2,1)
          }
          this.warehouseState = ''
          this.getListAll()
      },
      /**
       * @description: 分类搜索（方法描述）
       */
      onChangeInput(e){
          const value = e.target.value;
          this.searchValue = value
          console.log(this.searchValue)
      },
      onClickTab(record){
          console.log('点击时间')
          record.ischeck = true
      },
      onBlur(record){
            record.ischeck = false
      },
      onPressEnter(record){
          console.log(record)
            updatestornum({
                goodsId:record.goodsId,
                goodsSkuId:record.goodsSkuId,
                stockCount:record.stockCount
            },{}).then((res)=>{
                if(res.success){
                    record.ischeck = false
                    this.$message.success(res.logMessage)
                }else{
                    this.$message.warn(res.logMessage)
                }
            })
      },
      changeNumber(value,record){
        record.stockCount = value
      }
  },
}
</script>
<style lang="scss">
    .materia-form{
        .ant-form-item{
            width: 100%;
            .ant-form-item-control-wrapper{
                width: 100%;
            }
        }
    }
    .input-number{
        width: 100%;
        input{
            text-align: right;
            padding-right: 30px;
        }
    }
    .mateia-table-right{
        .ant-table-wrapper{
            padding: 0;
        }
        .ant-table-body-inner{
          .ant-table-tbody > tr > td:nth-child(2){
              border-right: 1px solid transparent;
          }
        }
        .ant-table-fixed-right .ant-table-body-inner  .ant-table-fixed{
          border-left: none;
        }
        .ant-table-body,.ant-table-body-inner{
            max-height: calc(100vh - 360px) !important;
        }
        .ant-table{
          height: calc(100vh - 300px);
            .ant-table-tbody > tr > td:nth-child(11){
                padding: 10px 0;
            }
        }
        .tab-row-warn{
            td{
                color: #AAAAAA;
            }

        }

    }
    .material-btn-pos-title{
        height: 36px;
        line-height: 36px;
        cursor: pointer;
    }
    .tree-input-search{
        margin: 10px 10px 0;
        width: 90%;
        .ant-input{
            height: 32px;
            line-height: 32px;
        }
    }
    /*.material-btn-pos-title:hover{*/
        /*background-color: #EBF2FD;*/
    /*}*/
</style>
<style lang="scss" scoped>
    .page-container-height{
        background-color: #fff;
        padding: 16px 18px 0;
        .material-top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .material-top-left{
                flex: 1;
                .materia-form-num{
                    padding-left: 22px;
                    span{
                        color: var(--co);
                        font-size: 18px;
                        font-weight: 700;
                    }
                }
                .materia-form-shua{
                    padding-left: 33px;
                    color: #387BFC;
                    cursor: pointer;
                    img{
                        width: 16px;
                        margin-bottom: 2px;
                    }
                }
            }
            .material-top-right{
                width: 100px;
                background:rgba(250,250,250,1);
                color: var(--co);
                position: relative;
                .material-btn-pos{
                    position: absolute;
                    top: 45px;
                    right: 0;
                    width:165px;
                    height:90px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 8px 0px rgba(59,59,59,0.16);
                    border-radius:6px;
                    color: #333333;
                    z-index: 100;
                    padding: 10px 0;
                }
            }
        }
        .materia-content{
            display: flex;
            margin-top: 16px;
            .commodity-shop-left{
                width: 200px;
                height: calc(100vh - 300px);
                margin-right: 12px;
                overflow: hidden;
                border: 1px solid #DDDDDD;
                .commodity-left-title{
                    cursor: pointer;
                    height: 45px;
                    line-height: 45px;
                    color: #333333;
                    font-size: 16px;
                    padding-left: 10px;
                }
                .commodity-tree{
                    padding-left: 10px;
                    overflow-y: auto;
                    overflow-x: hidden;
                }
            }
            .mateia-table-right{
                flex: 1;
                overflow: hidden;
                width: calc(100% - 250px);
                .table-name{
                    width: 190px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    img{
                        width: 22px;
                        margin-right: 4px;
                    }
                }
                .operator{
                    color: #387BFC;
                    span{
                        cursor: pointer;
                    }
                    span:last-child{
                        margin-left: 14px;
                    }
                    .operator-span{
                        color: #AAAAAA;
                    }
                }
                .location-span{
                    padding-right:20px;
                    display: inline-block;
                    height: 25px;
                    width: 100%;
                    line-height: 25px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    .table-name1{
        display: inline-block;
        width: 100%;
        height: 25px;
        line-height: 25px;
        padding:0 11px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
</style>


